module.exports = {
	"name": "webpack",
	"version": "1.4.1-beta1",
	"author": "Tobias Koppers @sokra",
	"description": "Packs CommonJs/AMD modules for the browser. Allows to split your codebase into multiple bundles, which can be loaded on demand. Support loaders to preprocess files, i.e. json, jade, coffee, css, less, ... and your custom stuff.",
	"dependencies": {
		"esprima": "~1.2.0",
		"mkdirp": "~0.5.0",
		"optimist": "~0.6.0",
		"uglify-js": "~2.4.13",
		"async": "~0.9.0",
		"enhanced-resolve": "~0.7.0",
		"memory-fs": "~0.1.0",
		"clone": "~0.1.15",
		"webpack-core": "~0.4.8",
		"node-libs-browser": "~0.4.0",
		"tapable": "~0.1.6"
	},
	"licenses": [
		{
			"type": "MIT",
			"url": "http://www.opensource.org/licenses/mit-license.php"
		}
	],
	"devDependencies": {
		"mocha": "~1.21.1",
		"should": "~4.0.4",
		"vm-browserify": "~0.0.0",
		"express": "~3.4.8",
		"webpack-dev-middleware": "^1.0.0",
		"worker-loader": "~0.5.0",
		"raw-loader": "~0.5.0",
		"json-loader": "~0.5.1",
		"jade-loader": "~0.6.1",
		"coffee-loader": "~0.7.1",
		"css-loader": "~0.9.0",
		"less-loader": "~0.7.0",
		"style-loader": "~0.8.0",
		"script-loader": "~0.6.0",
		"bundle-loader": "~0.5.0",
		"file-loader": "~0.7.2",
		"url-loader": "~0.5.0",
		"val-loader": "~0.5.0",
		"i18n-webpack-plugin": "~0.2.0",
		"extract-text-webpack-plugin": "~0.3.0",
		"component-webpack-plugin": "~0.2.0"
	},
	"engines": {
		"node": ">=0.6"
	},
	"repository": {
		"type": "git",
		"url": "http://github.com/webpack/webpack.git"
	},
	"homepage": "http://github.com/webpack/webpack",
	"main": "lib/webpack.js",
	"web": "lib/webpack.web.js",
	"bin": "./bin/webpack.js",
	"scripts": {
		"test": "mocha --reporter spec",
		"cover": "istanbul cover node_modules/mocha/bin/_mocha -- -R spec"
	}
}


/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/json-loader!(webpack)/package.json
 ** module id = 1
 ** module chunks = 0
 **/